export default "__VITE_ASSET__Byr3IhY2__"